/* eslint-disable react/jsx-boolean-value */
import ReactECharts from 'echarts-for-react';
import { useEffect, useState } from 'react';
import moment from 'moment';

import { getUserGrowth } from '../../../../services/Service';

const UserGrowthBarChart = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [mode, setMode] = useState('ThisYear'); // ThisYear, LastYear

  const fetchData = async (filter) => {
    try {
      setLoading(true);
      const res = await getUserGrowth({ ...filter });
      setData(res.data.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let startDate = '';
    let endDate = '';

    switch (mode) {
      case 'ThisYear':
        startDate = moment().startOf('year').toISOString();
        endDate = moment().endOf('year').toISOString();
        break;
      case 'LastYear':
        startDate = moment().subtract(1, 'year').startOf('year').toISOString();
        endDate = moment().subtract(1, 'year').endOf('year').toISOString();
        break;

      default:
        break;
    }

    fetchData({ endDate, startDate });
  }, [mode]);

  const dataKeys = data ? Object.keys(data) : [];
  const dataValues = data ? Object.values(data) : [];

  const chartOption = {
    title: {
      text: 'User Growth',
      left: 'left',
      textStyle: {
        color: '#468b47',
        lineHeight: 16,
      },
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {c}', // Tooltip shows name, value
    },
    xAxis: {
      type: 'category',
      data: dataKeys,
      axisTick: { show: false },
      axisLabel: {
        color: '#468b47', // Green color for x-axis labels
        fontWeight: 'bold',
      },
      axisLine: {
        show: false, // Remove x-axis line
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: '#468b47', // Green color for x-axis labels
        formatter: '{value}',
      },
    },
    series: [
      {
        data: dataValues,
        type: 'bar',
        itemStyle: {
          color: '#468b47', // Green color for bars
          borderRadius: 4,
        },
      },
    ],
  };

  return (
    <div
      style={{
        padding: '12px',
        borderRadius: '16px',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <select
        value={mode}
        style={{ position: 'absolute', right: '12px', top: '12px', zIndex: 1 }}
        onChange={(e) => setMode(e.target.value)}
      >
        <option value="ThisYear">This Year</option>
        <option value="LastYear">Last Year</option>
      </select>
      <ReactECharts
        notMerge={true}
        lazyUpdate={true}
        option={chartOption}
        showLoading={loading}
        style={{ height: '400px', minHeight: '300px' }}
      />
    </div>
  );
};
export default UserGrowthBarChart;
